// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.9995 3V0H17.9995V3H14.9995V5H17.9995V8H19.9995V5H22.9995V3H19.9995Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.4995 4C13.4995 3.29442 13.6324 2.61986 13.8745 2H1.99951V22H21.9995V8.61053C21.1367 9.17308 20.1063 9.5 18.9995 9.5C15.9619 9.5 13.4995 7.03757 13.4995 4ZM12.9995 18H10.9995V8H12.9995V18ZM7.99951 18H5.99951V11H7.99951V18ZM15.9995 18V13H17.9995V18H15.9995Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-add-filled')
export default class ChartAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-add-filled',
    }
  }
}
